export const GET_BADGE_COUNT = 'GET_BADGE_COUNT';
export const SET_BADGE_COUNT = 'SET_BADGE_COUNT';
